module.exports = __webpack_public_path__ + "img/foroptero.d5b93ded.svg";